import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveDynamicComponent as _resolveDynamicComponent, withCtx as _withCtx, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DynamicHtmlSlot = _resolveComponent("DynamicHtmlSlot")!
  const _component_Registration = _resolveComponent("Registration")!
  const _component_ForgotPassword = _resolveComponent("ForgotPassword")!
  const _component_EmailRegistration = _resolveComponent("EmailRegistration")!
  const _component_LoginForm = _resolveComponent("LoginForm")!
  const _component_OptInV2 = _resolveComponent("OptInV2")!
  const _component_CPI = _resolveComponent("CPI")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.step === _ctx.incentiveStep.REGISTRATION && _ctx.steps.includes(_ctx.incentiveStep.REGISTRATION))
      ? (_openBlock(), _createBlock(_component_Registration, { key: 0 }, {
          header: _withCtx(() => [
            (_ctx.slots.registrationHeaderElement)
              ? (_openBlock(), _createBlock(_component_DynamicHtmlSlot, {
                  key: 0,
                  element: _ctx.slots.registrationHeaderElement
                }, null, 8 /* PROPS */, ["element"]))
              : (_ctx.slots.registrationHeader)
                ? (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.slots.registrationHeader), { key: 1 }))
                : _createCommentVNode("v-if", true)
          ]),
          _: 1 /* STABLE */
        }))
      : _createCommentVNode("v-if", true),
    (_ctx.step === _ctx.incentiveStep.LOGIN && _ctx.steps.includes(_ctx.incentiveStep.LOGIN))
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
          (_ctx.isForgotPassword)
            ? (_openBlock(), _createBlock(_component_ForgotPassword, { key: 0 }))
            : (_ctx.isRegister)
              ? (_openBlock(), _createBlock(_component_EmailRegistration, { key: 1 }, {
                  header: _withCtx(() => [
                    (_ctx.slots.registrationHeaderElement)
                      ? (_openBlock(), _createBlock(_component_DynamicHtmlSlot, {
                          key: 0,
                          element: _ctx.slots.registrationHeaderElement
                        }, null, 8 /* PROPS */, ["element"]))
                      : (_ctx.slots.registrationHeader)
                        ? (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.slots.registrationHeader), { key: 1 }))
                        : _createCommentVNode("v-if", true)
                  ]),
                  _: 1 /* STABLE */
                }))
              : (_openBlock(), _createBlock(_component_LoginForm, { key: 2 }))
        ], 64 /* STABLE_FRAGMENT */))
      : (_ctx.step === _ctx.incentiveStep.OPT_IN && _ctx.steps.includes(_ctx.incentiveStep.OPT_IN))
        ? (_openBlock(), _createBlock(_component_OptInV2, { key: 2 }, {
            content: _withCtx(() => [
              (_ctx.slots.optInContentElement)
                ? (_openBlock(), _createBlock(_component_DynamicHtmlSlot, {
                    key: 0,
                    element: _ctx.slots.optInContentElement
                  }, null, 8 /* PROPS */, ["element"]))
                : (_ctx.slots.optInContent)
                  ? (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.slots.optInContent), { key: 1 }))
                  : _createCommentVNode("v-if", true)
            ]),
            _: 1 /* STABLE */
          }))
        : (_ctx.step === _ctx.incentiveStep.CPI && _ctx.steps.includes(_ctx.incentiveStep.CPI))
          ? (_openBlock(), _createBlock(_component_CPI, { key: 3 }))
          : _createCommentVNode("v-if", true)
  ], 64 /* STABLE_FRAGMENT */))
}